import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { forwardRef } from 'react';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import AbstractModal from '../AbstractModal/AbstractModal';
import { ModalTransition } from './ModalTransition';
import { PanelContext } from '../../context/PanelContext';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * For more details about this component please check the [Storybook page](https://private.hubteamqa.com/foundations-components-storybook/?path=/docs/transitional-modal--page).
 */
export const Modal = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      contextual,
      children,
      centered,
      ModalDialog,
      onCloseComplete,
      onCloseStart,
      onEsc,
      onOpenComplete,
      onOpenStart,
      rootNode,
      size,
      use,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, ["contextual", "children", "centered", "ModalDialog", "onCloseComplete", "onCloseStart", "onEsc", "onOpenComplete", "onOpenStart", "rootNode", "size", "use", DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE].map(_toPropertyKey));
  /**
   * PanelContext is only consumed by DialogFooter.
   * If DialogFooter is in a Modal which is a child of Panel,
   * the value of inPanel used by DialogFooter to set the background color
   * should be set to false to prevent a gray background color.
   */
  return /*#__PURE__*/_jsx(PanelContext.Provider, {
    value: {
      inPanel: false,
      inModal: true
    },
    children: /*#__PURE__*/_jsx(AbstractModal, Object.assign({}, rest, {
      ModalDialog: ModalDialog,
      onOpenStart: onOpenStart,
      onOpenComplete: onOpenComplete,
      onCloseStart: onCloseStart,
      onCloseComplete: onCloseComplete,
      rootNode: rootNode,
      onEsc: onEsc,
      use: use,
      size: size,
      centered: centered,
      _contextual: contextual,
      componentName: "Modal",
      Transition: ModalTransition,
      ref: ref,
      [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: dataComponentAttribute || 'Modal',
      children: children
    }))
  });
});
Modal.displayName = 'Modal';